/*
 * @Author: 秦少卫 nihaojob@163.com
 * @Date: 2025-05-27 09:28:28
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-07-29 15:52:25
 * @FilePath: /kuaitu/src/router/podRoutes.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/custom', // 模版商城路由
    component: () => import('@/views/custom/index.vue'),
  },
  {
    path: '/store', // 模版商城路由
    component: () => import('@/views/store/index.vue'),
  },
  {
    path: '/productDetail',
    component: () => import('@/views/productydDetail/index.vue'), // 对应商品详情组件
  },
  {
    path: '/commoditySettlement',
    component: () => import('@/views/commoditySettlement/index.vue'), // 对应商品结算组件
  },
  {
    path: '/shop/:code', // 店铺管理
    component: () => import('@/views/shop/index.vue'),
  },
  {
    path: '/shopProductydDetail',
    component: () => import('@/views/shopProductydDetail/index.vue'), // 对应商品详情组件
  },
  {
    path: '/shopCustom', // 模版商城路由
    component: () => import('@/views/shopCustom/index.vue'),
  },
  {
    path: '/Longtail-design', // 长尾云创编辑器（模版商城路由）
    component: () => import('@/views/Longtail-design/index.vue'),
  },
];

export default routes;
